import { GOOGLE_API_CLIENT_ID } from './const'

// function googleAuthInstance() {
//   return window.gapi.auth2.getAuthInstance()
// }

// function isGoogleAuthSignedIn() {
//   return googleAuthInstance().isSignedIn.get()
// }

/**
 * Returns google user object if signed in.
 */
// function getGoogleUser() {
//   return isGoogleAuthSignedIn() ? googleAuthInstance().currentUser.get() : null
// }

function downloadGoogleApiScript() {
  return new Promise((resolve) => {
    const gapiScript = document.createElement('script')
    gapiScript.setAttribute('src', 'https://accounts.google.com/gsi/client')
    gapiScript.async = true
    gapiScript.onload = () => {
      resolve()
    }
    document.head.appendChild(gapiScript)
  })
}

function initGoogleAuth() {
  // window.gapi.load('auth2', () => {
  //   window.gapi.auth2.init({
  //     client_id: GOOGLE_API_CLIENT_ID,
  //     cookiepolicy: 'single_host_origin',
  //   })
  // })
  return google.accounts.oauth2.initTokenClient({
    client_id: GOOGLE_API_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.email \
            https://www.googleapis.com/auth/userinfo.profile',
    callback: ''
  })
}

/**
 * Call this function before using any Google APIs.
 */
export function initGoogleAPI() {
  return new Promise((resolve, reject) => {
    downloadGoogleApiScript().then(() => {
      resolve(initGoogleAuth())
    })
  })
}

/**
 * Sign in to Google Oauth2.
 * If Google session exists, returns the googleUser object directly as a promise so that the caller can
 * handle this function the same way so google sign in.
 */
// export function signInToGoogle() {
//   return googleAuthInstance().signIn({
//     prompt: 'select_account',
//   })
// }

// export function signOutGoogle() {
//   if (!isGoogleAuthSignedIn()) {
//     return Promise.reject(new Error('Not sign in to Google'))
//   }
//   return googleAuthInstance().signOut()
// }

// export function getAccessTokenFromGoogleUser(googleUser) {
//   return googleUser.getAuthResponse(true).access_token
// }
